class ExtendSectionS2Pre extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS2] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initHeader());
    _safeInit(() => this.initSystemOverview());
    _safeInit(() => this.initAppDualtrack());
    _safeInit(() => this.initFlashCapture());
    _safeInit(() => this.initConnections());
    _safeInit(() => this.initComparison());
    _safeInit(() => this.initPreorderPacks());
    _safeInit(() => this.initVoiceDetailAudio());
    _safeInit(() => this.initPreorderProductOption());
    _safeInit(() => this.initPurchase());
  }

  initHeader() {
    const _bindSection = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.es2prehBound === "true") return;

      const openButton = this._q('[name="s2pre-header-open"]', sectionEl);
      const closeButton = this._q('[name="s2pre-header-close"]', sectionEl);
      const backdrop = this._q('[name="s2pre-header-backdrop"]', sectionEl);
      const drawer = this._q('[name="s2pre-header-drawer"]', sectionEl);

      if (!openButton || !closeButton || !backdrop || !drawer) return;
      sectionEl.dataset.es2prehBound = "true";

      const _openMenu = () => {
        backdrop.hidden = false;
        drawer.classList.add("es2preh__drawer--open");
        drawer.setAttribute("aria-hidden", "false");
        openButton.setAttribute("aria-expanded", "true");
        closeButton.focus();
      };

      const _closeMenu = () => {
        drawer.classList.remove("es2preh__drawer--open");
        drawer.setAttribute("aria-hidden", "true");
        openButton.setAttribute("aria-expanded", "false");
        backdrop.hidden = true;
        openButton.focus();
      };

      openButton.addEventListener("click", _openMenu);
      closeButton.addEventListener("click", _closeMenu);
      backdrop.addEventListener("click", _closeMenu);
      this._qa(".es2preh__cta, .es2preh__nav-link", drawer).forEach((link) => {
        link.addEventListener("click", _closeMenu);
      });

      sectionEl.addEventListener("keydown", (event) => {
        if (
          event.key === "Escape" &&
          openButton.getAttribute("aria-expanded") === "true"
        ) {
          _closeMenu();
        }
      });

      const _onResize = () => {
        if (!sectionEl.isConnected) {
          window.removeEventListener("resize", _onResize);
          return;
        }

        if (
          window.innerWidth > 1023 &&
          openButton.getAttribute("aria-expanded") === "true"
        ) {
          _closeMenu();
        }
      };

      window.addEventListener("resize", _onResize);
    };

    this._registerSectionLoad({
      key: "s2preHeader",
      className: "extend-s2pre-header",
      onLoad: (sectionEl) => {
        _bindSection(sectionEl);
      },
    });

    this._qa(".extend-s2pre-header").forEach((sectionEl) => {
      _bindSection(sectionEl);
    });
  }

  initSystemOverview() {
    const systemOverviewEl = this._q(".extend-s2pre-system-overview");
    if (!systemOverviewEl) return null;
    const features = this._qa(".es2preso__feature", systemOverviewEl);
    if (!features.length) return;

    this._registerSectionLoad(
      "system_overview_features",
      "extend_s2pre_system_overview",
      "renderSystemOverviewFeatures"
    );
    features.forEach((feature, i) => {
      const toggle = this._q(".es2preso__feature-toggle", feature);
      if (i == 0) {
        feature.classList.add("open");
      }
      if (!toggle) return;
      toggle.addEventListener("click", function () {
        const isOpen = feature.classList.toggle("open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });
  }

  initAppDualtrack() {
    const _bindSection = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.es2preadtBound === "true") return;
      sectionEl.dataset.es2preadtBound = "true";

      const modes = this._q(".es2preadt__modes", sectionEl);
      const track = this._q(".es2preadt__modes-track", sectionEl);

      const _getOffset = () => Number(track.dataset.es2preadtOffsetX || 0);

      const _setOffset = (x) => {
        track.dataset.es2preadtOffsetX = String(x);
        track.style.transform = `translateX(${x}px)`;
      };

      const _clampOffset = (x) => {
        const modeItems = this._qa(".es2preadt__mode", track);
        if (!modeItems.length) return 0;

        const viewportRect = modes.getBoundingClientRect();
        const firstRect = modeItems[0].getBoundingClientRect();
        const lastRect =
          modeItems[modeItems.length - 1].getBoundingClientRect();
        const currentX = _getOffset();

        // 子项当前位置已经包含 track 的位移，先还原到未位移的位置
        const originalLeft = firstRect.left - currentX;
        const originalRight = lastRect.right - currentX;
        const minX = viewportRect.right - originalRight;
        const maxX = viewportRect.left - originalLeft;

        if (minX > maxX) return maxX;
        return Math.max(minX, Math.min(maxX, x));
      };

      const _showScreen = (key) => {
        const target = this._q(
          '[name="es2preadt-screen"][data-key="' + key + '"]',
          sectionEl
        );
        if (!target) return;

        this._qa('[name="es2preadt-screen"]', sectionEl).forEach((screen) => {
          screen.classList.remove("es2preadt__screen--active");
        });
        target.classList.add("es2preadt__screen--active");
      };

      const _updateSubs = (key) => {
        const isMobile = window.innerWidth <= 1023;

        this._qa('[name="es2preadt-subs"]', sectionEl).forEach((group) => {
          group.classList.toggle(
            "es2preadt__subs--active",
            group.getAttribute("data-parent") === key
          );
          group.hidden = false;
        });

        this._qa('[name="es2preadt-sub"]', sectionEl).forEach((btn) => {
          const shouldHide =
            isMobile && btn.getAttribute("data-parent") !== key;

          if (shouldHide) {
            btn.style.setProperty("display", "none", "important");
          } else {
            btn.style.removeProperty("display");
          }
        });
      };

      const _positionMode = (modeBtn) => {
        if (!modes || !track || !modeBtn) return;

        if (window.innerWidth > 1023) {
          track.style.removeProperty("transform");
          delete track.dataset.es2preadtOffsetX;
          return;
        }

        const mode = modeBtn.closest(".es2preadt__mode");
        if (!mode) return;

        const modeItems = this._qa(".es2preadt__mode", track);
        const index = modeItems.indexOf(mode);
        if (index === -1) return;

        const viewportRect = modes.getBoundingClientRect();
        const modeRect = mode.getBoundingClientRect();
        const currentX = _getOffset();
        let distance;

        if (index === 0) {
          distance = viewportRect.left - modeRect.left;
        } else if (index === modeItems.length - 1) {
          distance = viewportRect.right - modeRect.right;
        } else {
          const viewportCenter = (viewportRect.left + viewportRect.right) / 2;
          const modeCenter = (modeRect.left + modeRect.right) / 2;
          distance = viewportCenter - modeCenter;
        }

        _setOffset(_clampOffset(currentX + distance));
      };

      const _selectMode = (modeBtn) => {
        const key = modeBtn.getAttribute("data-key");
        const firstSub = modeBtn.getAttribute("data-first-sub");
        let screenKey = key;

        this._qa('[name="es2preadt-mode"]', sectionEl).forEach((btn) => {
          btn.classList.remove("es2preadt__mode-btn--active");
          btn.setAttribute("aria-pressed", "false");
        });
        modeBtn.classList.add("es2preadt__mode-btn--active");
        modeBtn.setAttribute("aria-pressed", "true");

        _updateSubs(key);

        // 清除所有模式中子选项的 active
        this._qa('[name="es2preadt-sub"]', sectionEl).forEach((btn) => {
          btn.classList.remove("es2preadt__sub-btn--active");
          btn.setAttribute("aria-pressed", "false");
        });

        if (firstSub) {
          this._qa(
            '[name="es2preadt-sub"][data-parent="' + key + '"]',
            sectionEl
          ).forEach((btn) => {
            const isFirst = btn.getAttribute("data-key") === firstSub;
            btn.classList.toggle("es2preadt__sub-btn--active", isFirst);
            btn.setAttribute("aria-pressed", isFirst ? "true" : "false");
          });
          screenKey = firstSub;
        }

        _showScreen(screenKey);
        _positionMode(modeBtn);
      };

      const _selectSub = (subBtn) => {
        const parent = subBtn.getAttribute("data-parent");
        const parentMode = this._q(
          '[name="es2preadt-mode"][data-key="' + parent + '"]',
          sectionEl
        );

        // 同步选中父级 mode，但不重置刚点击的子选项
        if (parentMode) {
          this._qa('[name="es2preadt-mode"]', sectionEl).forEach((btn) => {
            const isActive = btn === parentMode;
            btn.classList.toggle("es2preadt__mode-btn--active", isActive);
            btn.setAttribute("aria-pressed", isActive ? "true" : "false");
          });
          _positionMode(parentMode);
        }

        _updateSubs(parent);

        this._qa('[name="es2preadt-sub"]', sectionEl).forEach((btn) => {
          const isActive = btn === subBtn;
          btn.classList.toggle("es2preadt__sub-btn--active", isActive);
          btn.setAttribute("aria-pressed", isActive ? "true" : "false");
        });

        _showScreen(subBtn.getAttribute("data-key"));
      };

      // 拖动结束后，拦截浏览器可能派发的那一次点击
      let suppressClick = false;
      let suppressClickTimer;

      sectionEl.addEventListener(
        "click",
        (event) => {
          if (!suppressClick || !modes || !modes.contains(event.target)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
          clearTimeout(suppressClickTimer);
        },
        true
      );

      sectionEl.addEventListener("click", (event) => {
        const modeBtn = event.target.closest('[name="es2preadt-mode"]');
        if (modeBtn && sectionEl.contains(modeBtn)) {
          _selectMode(modeBtn);
          return;
        }

        const subBtn = event.target.closest('[name="es2preadt-sub"]');
        if (subBtn && sectionEl.contains(subBtn)) {
          _selectSub(subBtn);
        }
      });

      if (modes && track) {
        let touchStartX = 0;
        let touchStartY = 0;
        let startOffsetX = 0;
        let direction = null;
        let isDragging = false;
        let previousTransition = "";

        track.addEventListener(
          "touchstart",
          (event) => {
            if (window.innerWidth > 1023 || event.touches.length !== 1) return;

            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
            startOffsetX = _getOffset();
            direction = null;
            isDragging = false;
            previousTransition = track.style.transition;
          },
          { passive: true }
        );

        track.addEventListener(
          "touchmove",
          (event) => {
            if (window.innerWidth > 1023 || event.touches.length !== 1) return;

            const deltaX = event.touches[0].clientX - touchStartX;
            const deltaY = event.touches[0].clientY - touchStartY;

            if (!direction) {
              if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 6) return;
              direction =
                Math.abs(deltaX) > Math.abs(deltaY) ? "horizontal" : "vertical";
            }

            if (direction !== "horizontal") return;

            event.preventDefault();
            isDragging = true;
            track.style.transition = "none";
            _setOffset(_clampOffset(startOffsetX + deltaX));
          },
          { passive: false }
        );

        const _endTouch = () => {
          if (isDragging) {
            suppressClick = true;
            clearTimeout(suppressClickTimer);
            suppressClickTimer = setTimeout(() => {
              suppressClick = false;
            }, 350);
          }

          track.style.transition = previousTransition;
          direction = null;
          isDragging = false;
        };

        track.addEventListener("touchend", _endTouch);
        track.addEventListener("touchcancel", _endTouch);
      }

      const _handleResize = () => {
        if (!sectionEl.isConnected) {
          window.removeEventListener("resize", _handleResize);
          return;
        }

        const activeMode = this._q(
          '[name="es2preadt-mode"].es2preadt__mode-btn--active',
          sectionEl
        );

        _updateSubs(activeMode ? activeMode.getAttribute("data-key") : null);

        if (window.innerWidth > 1023) {
          if (track) {
            track.style.removeProperty("transform");
            delete track.dataset.es2preadtOffsetX;
          }
          return;
        }

        _positionMode(activeMode);
      };

      window.addEventListener("resize", _handleResize);
      _handleResize();
    };

    this._registerSectionLoad({
      key: "s2preAppDualtrack",
      className: "extend-s2pre-app-dualtrack",
      onLoad: (sectionEl) => {
        _bindSection(sectionEl);
      },
    });

    this._qa(".extend-s2pre-app-dualtrack").forEach((sectionEl) => {
      _bindSection(sectionEl);
    });
  }

  initFlashCapture() {
    const _bindFlashCapture = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.es2prefcBound === "true") return;

      const panelEl = this._q('[name="es2prefc-panel"]', sectionEl);
      if (!panelEl) return;

      const timerEl = this._q('[name="es2prefc-timer"]', panelEl);
      const statusEl = this._q('[name="es2prefc-status"]', panelEl);
      const recBtn = this._q('[name="es2prefc-rec"]', panelEl);
      if (!timerEl || !recBtn) return;

      sectionEl.dataset.es2prefcBound = "true";

      const state = {
        timerId: null,
        seconds: 0,
      };

      const _formatTime = (total) => {
        const m = Math.floor(total / 60);
        const s = total % 60;
        return (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
      };

      const _setState = (stateName) => {
        const text = panelEl.getAttribute("data-" + stateName + "-text");

        panelEl.classList.remove(
          "es2prefc__panel--recording",
          "es2prefc__panel--saved"
        );

        if (stateName !== "idle") {
          panelEl.classList.add("es2prefc__panel--" + stateName);
        }

        if (statusEl && text) {
          statusEl.textContent = text;
        }

        recBtn.setAttribute(
          "aria-pressed",
          stateName === "recording" ? "true" : "false"
        );
      };

      recBtn.addEventListener("click", () => {
        if (state.timerId) {
          clearInterval(state.timerId);
          state.timerId = null;
          _setState("saved");
          return;
        }

        state.seconds = 0;
        timerEl.textContent = _formatTime(state.seconds);
        _setState("recording");

        state.timerId = setInterval(() => {
          if (!document.body.contains(sectionEl)) {
            clearInterval(state.timerId);
            state.timerId = null;
            return;
          }

          state.seconds += 1;
          timerEl.textContent = _formatTime(state.seconds);
        }, 1000);
      });
    };

    this._registerSectionLoad({
      key: "s2preFlashCapture",
      className: "extend-s2pre-flash-capture",
      onLoad: _bindFlashCapture,
    });

    this._qa(".extend-s2pre-flash-capture").forEach(_bindFlashCapture);
  }

  initConnections() {
    const _selectConnectionsTab = (sectionEl, key) => {
      const panel = this._q(
        '[name="es2precn-panel"][data-key="' + key + '"]',
        sectionEl
      );
      if (!panel) return;

      this._qa('[name="es2precn-tab"]', sectionEl).forEach((tab) => {
        const isActive = tab.getAttribute("data-key") === key;
        tab.classList.toggle("es2precn__tab--active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      this._qa('[name="es2precn-panel"]', sectionEl).forEach((item) => {
        item.classList.remove("es2precn__panel--active");
      });
      panel.classList.add("es2precn__panel--active");
    };

    const _bindConnections = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.es2precnBound === "true") return;
      if (!this._q('[name="es2precn-tab"]', sectionEl)) return;
      sectionEl.dataset.es2precnBound = "true";

      sectionEl.addEventListener("click", (event) => {
        const tabBtn = event.target.closest('[name="es2precn-tab"]');
        if (!tabBtn || !sectionEl.contains(tabBtn)) return;
        _selectConnectionsTab(sectionEl, tabBtn.getAttribute("data-key"));
      });
    };

    this._registerSectionLoad({
      key: "s2preConnections",
      className: "extend-s2pre-connections",
      onLoad: _bindConnections,
    });

    this._qa(".extend-s2pre-connections").forEach(_bindConnections);
  }

  initComparison() {
    const comparisonEl = this._q(".extend-s2pre-comparison");
    if (!comparisonEl) return null;

    const metas = this._qa(".es2precp__products_2");
    if (!metas || !metas.length) return;

    const throttle = (fn, delay) => {
      let timer = null;

      return function (...args) {
        if (timer) return;

        timer = setTimeout(() => {
          fn.apply(this, args);
          timer = null;
        }, delay);
      };
    };

    const handleScroll = throttle(() => {
      metas.forEach((meta) => {
        const rect = meta.getBoundingClientRect();

        if (rect.top <= 0) {
          meta.classList.add("is-stuck");
        } else {
          meta.classList.remove("is-stuck");
        }
      });
    }, 16);

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
  }

  initPreorderPacks() {
    const sections = Array.from(this._qa(".extend-s2pre-preorder") || []);

    if (!sections.length) return null;

    sections.forEach((section) => {
      const cards = Array.from(section.querySelectorAll(".es2prepp__pack"));
      const media = Array.from(section.querySelectorAll(".es2prepp__media"));
      const buttons = Array.from(section.querySelectorAll(".es2prepp__button"));

      if (!cards.length) return;

      const syncSelection = () => {
        const selectedCard = cards.find((card) => {
          const radio = card.querySelector(".es2prepp__pack-radio");
          return radio && radio.checked;
        });

        if (!selectedCard) return;

        const position = selectedCard.getAttribute("data-position");

        cards.forEach((card) => {
          card.classList.toggle("is-selected", card === selectedCard);
        });

        media.forEach((item) => {
          item.classList.toggle(
            "is-active",
            item.getAttribute("data-position") === position
          );
        });

        buttons.forEach((button) => {
          button.classList.toggle(
            "is-active",
            button.getAttribute("data-position") === position
          );
        });
      };

      if (!section.querySelector(".es2prepp__pack-radio:checked")) {
        const firstRadio = cards[0].querySelector(".es2prepp__pack-radio");

        if (firstRadio) firstRadio.checked = true;
      }

      syncSelection();

      if (section.dataset.preorderPacksInitialized === "true") return;
      section.dataset.preorderPacksInitialized = "true";

      section.addEventListener("change", (event) => {
        if (event.target && event.target.matches(".es2prepp__pack-radio")) {
          syncSelection();
        }
      });

      section.addEventListener("click", (event) => {
        const card = event.target.closest(".es2prepp__pack");

        if (!card || !section.contains(card)) return;
        if (event.target.closest("a, label, input, button")) return;

        const radio = card.querySelector(".es2prepp__pack-radio");
        if (!radio || radio.checked) return;

        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    this._registerSectionLoad(
      "s2pre_preorder_packs",
      "extend_s2pre_preorder_packs",
      "initPreorderPacks"
    );
  }

  initVoiceDetailAudio() {
    const sections = Array.from(this._qa(".extend-s2pre-voice-detail") || []);

    sections.forEach((section) => {
      const audios = Array.from(
        section.querySelectorAll(".es2prevd__audio[data-audio-source]")
      );

      const controls = Array.from(section.querySelectorAll("[data-audio-key]"));

      if (!audios.length || !controls.length) return;
      if (section.dataset.voiceDetailAudioInitialized === "true") return;

      section.dataset.voiceDetailAudioInitialized = "true";

      const findAudio = (key) =>
        audios.find((audio) => audio.getAttribute("data-audio-source") === key);

      const controlsFor = (key) =>
        controls.filter(
          (control) => control.getAttribute("data-audio-key") === key
        );

      const selectSide = (key) => {
        section.classList.add("has-audio-selection");

        section.querySelectorAll(".es2prevd__legend").forEach((legend) => {
          const button = legend.querySelector(
            ".es2prevd__legend-label[data-audio-key]"
          );

          legend.classList.toggle(
            "is-selected",
            Boolean(button && button.getAttribute("data-audio-key") === key)
          );
        });
      };

      const syncPlaybackState = (key, playing) => {
        controlsFor(key).forEach((control) => {
          control.setAttribute("aria-pressed", playing ? "true" : "false");

          const currentLabel = control.getAttribute("aria-label") || "";
          const audioName = currentLabel.replace(/^(Play|Pause) /, "");

          control.setAttribute(
            "aria-label",
            `${playing ? "Pause" : "Play"} ${audioName}`
          );
        });
      };

      const syncProgress = (audio) => {
        const key = audio.getAttribute("data-audio-source");
        let progress = 0;

        if (Number.isFinite(audio.duration) && audio.duration > 0) {
          progress = Math.min(
            100,
            Math.max(0, (audio.currentTime / audio.duration) * 100)
          );
        }

        controlsFor(key).forEach((control) => {
          control.style.setProperty("--play-progress", `${progress}%`);
        });
      };

      const resetAudio = (audio) => {
        audio.pause();
        audio.currentTime = 0;
        syncProgress(audio);
        syncPlaybackState(audio.getAttribute("data-audio-source"), false);
      };

      section.addEventListener("click", (event) => {
        const control = event.target.closest("[data-audio-key]");

        if (!control || !section.contains(control)) return;

        const key = control.getAttribute("data-audio-key");
        const selectedAudio = findAudio(key);

        if (!selectedAudio) return;

        selectSide(key);

        if (!selectedAudio.paused) {
          selectedAudio.pause();
          return;
        }

        audios.forEach((audio) => {
          if (audio !== selectedAudio) resetAudio(audio);
        });

        const playPromise = selectedAudio.play();

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            syncPlaybackState(key, false);
          });
        }
      });

      audios.forEach((audio) => {
        const key = audio.getAttribute("data-audio-source");

        audio.addEventListener("play", () => {
          syncPlaybackState(key, true);
        });

        audio.addEventListener("pause", () => {
          syncPlaybackState(key, false);
        });

        audio.addEventListener("timeupdate", () => {
          syncProgress(audio);
        });

        audio.addEventListener("seeked", () => {
          syncProgress(audio);
        });

        audio.addEventListener("ended", () => {
          resetAudio(audio);
        });
      });

      section.addEventListener("shopify:section:unload", () => {
        audios.forEach((audio) => audio.pause());
      });
    });

    this._registerSectionLoad(
      "s2pre_voice_detail_audio",
      "extend_s2pre_voice_detail",
      "initVoiceDetailAudio"
    );
  }

  initPreorderProductOption() {
    const sectionEl = this._q(".extend-s2pre-preorder-hero");
    if (!sectionEl) return null;

    const optionInput = this._q(".es2preph__option-input", sectionEl);
    const purchaseButton = this._q("a.es2preph__button", sectionEl);
    const optionName = this._q("[data-option-summary-name]", sectionEl);
    const optionPrice = this._q("[data-option-summary-price]", sectionEl);
    const totalPrice = this._q("[data-setup-total-price]", sectionEl);
    const totalComparePrice = this._q("[data-setup-total-compare]", sectionEl);

    if (!purchaseButton || !purchaseButton.dataset.mainVariantId) {
      return null;
    }

    if (!optionInput) {
      return null;
    }

    // 固定选中配件，不提供手动切换。
    optionInput.checked = true;
    optionInput.disabled = true;

    const _updateSelection = () => {
      const mainVariantId = purchaseButton.dataset.mainVariantId;
      const optionVariantId = purchaseButton.dataset.optionVariantId;
      const selected = Boolean(optionVariantId);

      const root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : "/";

      const cartPath = root.replace(/\/?$/, "/") + "cart/";

      purchaseButton.href =
        cartPath +
        mainVariantId +
        ":1" +
        (selected ? "," + optionVariantId + ":1" : "");

      if (optionName) {
        optionName.textContent = selected
          ? optionInput.dataset.optionTitle || ""
          : "No optional accessories selected";
      }

      if (optionPrice) {
        optionPrice.textContent = selected
          ? optionInput.dataset.optionFormattedPrice || ""
          : "";
        optionPrice.hidden = !selected;
      }

      if (totalPrice) {
        totalPrice.textContent = selected
          ? purchaseButton.dataset.totalFormattedPrice || ""
          : purchaseButton.dataset.mainFormattedPrice || "";
      }

      if (totalComparePrice) {
        const hasDiscount = selected
          ? purchaseButton.dataset.totalHasDiscount === "true"
          : purchaseButton.dataset.mainHasDiscount === "true";

        totalComparePrice.textContent = selected
          ? purchaseButton.dataset.totalOriginalPrice || ""
          : purchaseButton.dataset.mainOriginalPrice || "";

        totalComparePrice.hidden = !hasDiscount;
      }
    };

    _updateSelection();

    return optionInput;
  }

  initPurchase() {
    const _bindSection = (sectionEl) => {
      if (!sectionEl) return;

      const countdownEl = this._q('[name="es2prep-countdown"]', sectionEl);

      if (!countdownEl) return;
      if (countdownEl.dataset.es2prepCountdownBound === "true") return;

      const endValue = countdownEl.getAttribute("data-end") || "";
      const endTime = Date.parse(endValue);

      if (!/(Z|[+-]\d{2}:\d{2})$/i.test(endValue) || !isFinite(endTime)) {
        countdownEl.hidden = true;
        console.warn("Purchase countdown: invalid end date.", endValue);
        return;
      }

      const daysEl = this._q('[name="es2prep-countdown-days"]', countdownEl);
      const hoursEl = this._q('[name="es2prep-countdown-hours"]', countdownEl);
      const minutesEl = this._q(
        '[name="es2prep-countdown-minutes"]',
        countdownEl
      );
      const secondsEl = this._q(
        '[name="es2prep-countdown-seconds"]',
        countdownEl
      );

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      countdownEl.dataset.es2prepCountdownBound = "true";

      let timer = null;
      let stopped = false;

      const _pad = (value) => {
        return value < 10 ? "0" + value : String(value);
      };

      const _cleanup = () => {
        if (stopped) return;
        stopped = true;

        if (timer !== null) {
          window.clearInterval(timer);
          timer = null;
        }

        document.removeEventListener("shopify:section:unload", _onUnload);

        delete countdownEl.dataset.es2prepCountdownBound;
      };

      const _onUnload = (event) => {
        const target = event.target;

        if (target && (target === sectionEl || target.contains(sectionEl))) {
          _cleanup();
        }
      };

      const _update = () => {
        if (stopped) return;

        if (
          !document.documentElement.contains(sectionEl) ||
          !sectionEl.contains(countdownEl)
        ) {
          _cleanup();
          return;
        }

        const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));

        const days = Math.floor(remaining / 86400);
        const hours = Math.floor((remaining % 86400) / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        daysEl.textContent = _pad(days);
        hoursEl.textContent = _pad(hours);
        minutesEl.textContent = _pad(minutes);
        secondsEl.textContent = _pad(seconds);

        countdownEl.hidden = false;

        if (remaining === 0) {
          countdownEl.classList.add("es2prep__countdown--ended");
          _cleanup();
        }
      };

      document.addEventListener("shopify:section:unload", _onUnload);

      _update();

      if (!stopped) {
        timer = window.setInterval(_update, 1000);
      }
    };

    this._registerSectionLoad({
      key: "s2prePurchase",
      className: "extend-s2pre-purchase",
      onLoad: (sectionEl) => {
        _bindSection(sectionEl);
      },
    });

    this._qa(".extend-s2pre-purchase").forEach((sectionEl) => {
      _bindSection(sectionEl);
    });
  }
}
